import React from "react";
import UseTitle from "../components/useTitle";
import "./Home.scss";

const Home = () => {
  // Définition du titre de la page
  UseTitle("Accueil");

  return (
    <div className="home">
      <h1>Accueil</h1>
      <p>
        Voici le gestionnaire de fiche de personnages pour le jeu de rôle dans
        l'univers{" "}
        <a href="https://le-monde-de-doma.ovh" target="_blank">
          Le monde de Doma
        </a>
      </p>
    </div>
  );
};

export default Home;
